import React from 'react';
import { CheckCircle } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function WhatYouGet() {
  const deliverables = [{
    title: 'El Manual Maestro del Protocolo',
    desc: 'Guía completa anti-inflamatoria de 3 días en formato PDF.'
  }, {
    title: 'El Semáforo de Alimentos Reactivos',
    desc: 'Identifica qué te hincha hoy mismo con esta tabla visual.'
  }, {
    title: 'Secuencia de Movimiento Linfático',
    desc: 'Rutina de 5 minutos diseñada específicamente para drenar líquidos.'
  }, {
    title: "Lista de Compras 'Zero-Inflam'",
    desc: 'Para ir directo al grano en el supermercado sin dudas.'
  }, {
    title: 'Diario de Reacción de 72h',
    desc: 'Plantilla para localizar y registrar tus disparadores personales.'
  }, {
    title: 'Guía de Emergencia',
    desc: 'Cómo deshincharse en 24h tras una cena pesada o evento social.'
  }];
  return <section className="bg-white py-20 px-4" data-id="element-199">
      <div className="max-w-[720px] mx-auto" data-id="element-200">
        <FadeIn data-id="element-201">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1A1A1A] mb-12 text-center" data-id="element-202">
            ¿Qué incluye el Protocolo?
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-203">
          {deliverables.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-204">
              <div className="bg-[#FDFAF5] p-6 rounded-2xl border border-[#E8F5E2] h-full transition-all hover:shadow-md" data-id="element-205">
                <CheckCircle className="w-8 h-8 text-[#2D5A27] mb-4" data-id="element-206" />
                <h3 className="text-lg font-bold text-[#1A1A1A] mb-2" data-id="element-207">
                  {item.title}
                </h3>
                <p className="text-sm text-[#5A5A5A] leading-relaxed" data-id="element-208">
                  {item.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}